export const PLAN_NAMES: Record<string, string> = {
  trevor_credit_pro: 'Pro',
  trevor_credit_enterprise: 'Enterprise',
};

export const getDateInterval = (date1: Date, date2: Date) => {
  return `${date1.getDate()} ${date1.toLocaleString('default', {
    month: 'long',
  })} - ${date2.getDate()} ${date2.toLocaleString('default', {
    month: 'long',
  })}`;
};
